export default "__VITE_ASSET__BtYYUoFr__"